import React from "react";
import styled from "styled-components";

const StyledTitle = styled.div`
  font-size: 27px;
  font-weight: 400;
  color: ${({ theme }) => theme.titleColor};
  padding: 5px;
  position: relative;

  ::after {
    content: "";
    width: 90%;
    height: 2px;
    position: absolute;
    left: 5%;
    bottom: 0;
    background-color: ${({ theme }) => theme.titleColor};
    transition: 0.2s;
    transform: scaleX(1);
  }

  :hover {
    ::after {
      transform: scaleX(0);
    }
  }
`;

const Title = ({ title }) => {
  return <StyledTitle>{title}</StyledTitle>;
};

export default Title;
